import { render, staticRenderFns } from "./VerticalNavMenuDrag.vue?vue&type=template&id=d8a59ca0&"
import script from "./VerticalNavMenuDrag.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuDrag.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuDrag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports